/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, dot-notation */
export const storeUserDataInLocalStorage = (token: string): void => {
  try {
    const parsed = JSON.parse(atob(token.split('.')[1]))
    if (parsed['https://xxllnc.nl/name']) localStorage.setItem('nickname', parsed['https://xxllnc.nl/name'])
    if (parsed['https://xxllnc.nl/organization_name'])
      localStorage.setItem('organizationName', parsed['https://xxllnc.nl/organization_name'])
    if (parsed['org_id']) localStorage.setItem('organizationId', parsed['org_id'])
  } catch (err) {
    // do nothing
  }
}
